import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import config from "../config/config";
import './Login.css';

const Login = ({ setIsAuthenticated }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    if (!username || !password) {
      setError("Veuillez remplir tous les champs.");
      setLoading(false);
      return;
    }

    try {
      console.log("Making API call to:", `${config.API_URL}/api/login`); // Debug log
      console.log("Username:", username); // Debug log
      const res = await fetch(`${config.API_URL}/api/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      console.log("Response status:", res.status); // Debug log
      console.log("Response headers:", res.headers); // Debug log

      const data = await res.json();
      console.log("Response data:", data); // Debug log

      if (res.ok) {
        login(data.token);
        setIsAuthenticated(true);
        navigate("/");
      } else {
        setError(data.error || "Identifiants invalides");
      }
    } catch (error) {
      console.error("Login error caught:", error);
      setError("Impossible de se connecter au serveur. Veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <div className="login-logo">
            <img src="/images/Logo.jpg" alt="Troupe Anouar Logo" className="logo-image" />
          </div>
          <h1 className="login-title">Mabrouk Events</h1>
          <p className="login-subtitle">Connectez-vous à votre compte</p>
        </div>

        <form onSubmit={handleLogin} className="login-form">
          <div className="form-group">
            <label htmlFor="username" className="form-label">
              Nom d'utilisateur
            </label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="form-input"
              placeholder="Entrez votre nom d'utilisateur"
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">
              Mot de passe
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="form-input"
              placeholder="Entrez votre mot de passe"
              required
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            className="login-button"
            disabled={loading}
          >
            {loading && <div className="loading-spinner"></div>}
            {loading ? "Connexion..." : "Se connecter"}
          </button>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}
        </form>

        <div className="login-footer">
          <p>Système de gestion Troupe Anouar © 2025</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
